import { Box, Typography, List, ListItem, Grid } from "@mui/material";

const normalizeToArray = (value) => {
  if (Array.isArray(value)) {
    if (value.some(Array.isArray)) {
      return value
        .flat()
        .map((v) => v.toString().trim())
        .filter((v) => v);
    }
    return value.map((v) => v.toString().trim()).filter((v) => v);
  }
  if (typeof value === "string") {
    return value
      .split(/[\n•\t]+/)
      .map((v) => v.trim())
      .filter((v) => v);
  }
  return [];
};

const FileChangesViewHistory = ({ attachedFileNames, view }) => {
    const [before = [], after = []] = attachedFileNames || [];
    const beforeFiles = normalizeToArray(before);
    const afterFiles = normalizeToArray(after);
  
    const added = afterFiles.filter(f => !beforeFiles.includes(f));
    const removed = beforeFiles.filter(f => !afterFiles.includes(f));
    const unchanged = afterFiles.filter(f => beforeFiles.includes(f));
  
    if (view === "before") {
      return (
        <List dense>
          {beforeFiles.map((file, index) => {
            const isRemoved = removed.includes(file);
            return (
              <ListItem
                key={index}
                sx={{ color: isRemoved ? "red" : "text.secondary", pl: 1 }}
              >
                • {file}
              </ListItem>
            );
          })}
        </List>
      );
    }
  
    if (view === "after") {
      const combined = [
        ...afterFiles.map(file => ({
          file,
          color: added.includes(file) ? "green" : "text.secondary",
          label: added.includes(file) ? "(agregado)" : "(sin cambios)",
        })),
        ...removed.map(file => ({
          file,
          color: "red",
          label: "(eliminado)",
        })),
      ];
  
      return (
        <List dense>
          {combined.map(({ file, color, label }, index) => (
            <ListItem key={index} sx={{ color, pl: 1 }}>
              • {file} {label}
            </ListItem>
          ))}
        </List>
      );
    }
  
    return null;
  };
  

export default FileChangesViewHistory;
